import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LoiHttpClient } from 'loi-lti-common';
import { ModuleInfoModel } from '../models/moduleinfo.model';
import { CustomRequestOptions } from '../utils/custom-request-options';
import { ModulePartsModel } from '../models/module-parts.model';

@Injectable({
  providedIn: 'root'
})

export class ModuleService {
  constructor(
    private httpClient: LoiHttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private requestOptions: CustomRequestOptions) { }

  getModuleInfo(moduleId: string): Observable<ModuleInfoModel> {
    console.log(`retreiving module info for module ${moduleId}`);
    return this.httpClient.get<ModuleInfoModel>(`${this.baseUrl}api/Module/${moduleId}/info`, this.requestOptions);
  }

  getModuleParts(moduleId: string): Observable<ModulePartsModel> {
    console.log(`retreiving module parts for module ${moduleId}`);
    return this.httpClient.get<ModulePartsModel>(`${this.baseUrl}api/Module/${moduleId}/parts`, this.requestOptions);
  }
}
